export default __webpack_public_path__ + "static/media/main-header-03.d1af1978.jpg";